
/*
 * Filters functionality
 */


// Global vars
var biro_filters_form;


// On page load
jQuery( function( $ ) {

	// Init
	biro_filters_form = $( '.filters-form' );

	// Submit when filter is changed
	biro_filters_form.on( 'change', 'select', function() {

		biro_filters_form.submit();

	});

});